import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<picture class=\"full-width\"><source media=\"(max-width: 599px)\" srcset=\"/estimate/img/reason_sp.png\"><source media=\"(min-width: 600px)\" srcset=\"/estimate/img/reason.png\"><img src=\"/estimate/img/reason.png\" alt=\"\" class=\"full-width\"></picture><picture class=\"full-width\"><source media=\"(max-width: 599px)\" srcset=\"/estimate/img/4parts_sp.png\"><source media=\"(min-width: 600px)\" srcset=\"/estimate/img/4parts.png\"><img src=\"/estimate/img/4parts.png\" alt=\"\" class=\"full-width\"></picture>", 2)
const _hoisted_3 = { class: "bg-grey-3 overflow-hidden" }

import { ref, ComponentPublicInstance } from 'vue'
import { IndexPageParts } from '@/estimate/components/page-parts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const form = ref<ComponentPublicInstance | null>()

function scrollToForm() {
  form.value?.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IndexPageParts).IndexVisual),
    _createElementVNode("img", {
      src: "/estimate/img/assessment_btn.png",
      alt: "今すぐ無料査定してみる",
      class: "cursor-pointer fixed-bottom-right m",
      style: {"z-index":"5000","max-width":"50vw"},
      onClick: scrollToForm
    }),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.bgYellowStripe)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _hoisted_1,
        _createVNode(_unref(IndexPageParts).IndexForm, {
          style: {"margin":"80px auto"},
          ref_key: "form",
          ref: form
        }, null, 512),
        _createVNode(_unref(IndexPageParts).IndexFlow, { style: {"margin":"80px auto"} }),
        _createVNode(_unref(IndexPageParts).IndexPromise, { style: {"margin":"80px auto"} })
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.container)
    }, [
      _createVNode(_unref(IndexPageParts).IndexRecord, { style: {"margin":"80px auto"} }),
      _createVNode(_unref(IndexPageParts).IndexUsedCar, { style: {"margin":"80px auto"} })
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _createVNode(_unref(IndexPageParts).IndexFaq, { style: {"margin":"80px auto"} })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.container)
    }, [
      _createVNode(_unref(IndexPageParts).IndexContact, { style: {"margin":"80px auto"} })
    ], 2)
  ], 64))
}
}

})